import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinnerLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	stroke: "currentColor",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("style", { children: "\n    .spinner-container {\n  transform-origin: center;\n  animation: line-animation-a 2s linear infinite;\n    }\n    .spinner-container circle {\n      stroke-linecap: round;\n      animation: line-animation-b 1.5s ease-in-out infinite;\n    }\n    @keyframes line-animation-a {\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n    @keyframes line-animation-b {\n      0% {\n        stroke-dasharray: 0 150;\n        stroke-dashoffset: 0;\n      }\n      47.5% {\n        stroke-dasharray: 42 150;\n        stroke-dashoffset: -16;\n      }\n      95%,\n      100% {\n        stroke-dasharray: 42 150;\n        stroke-dashoffset: -59;\n      }\n    }\n  " }), /* @__PURE__ */ _jsx("g", {
		className: "spinner-container",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 9.5,
			fill: "none",
			strokeWidth: 3,
			stroke: "currentColor"
		})
	})]
});
export default SvgSpinnerLine;
